<template>
  <div class="bookDetails">
    <el-dialog title="提示" :visible.sync="dialogVisible" width="560px" :append-to-body="true">
      <span v-show="diaStatus === 2">确定要取消这条预约吗？</span>
      <span v-show="diaStatus === 0">确认要拒绝这条预约订单吗？</span>
      <p v-if="cancelStatus == 0">已超过预约可退定金时间，若顾客已支付定金/使用了划扣次数，取消订单后，定金/划扣次数将<samp class="themeFC">不会</samp>退回顾客</p>
      <p v-if="cancelStatus == 1">若顾客已支付定金/使用了划扣次数，{{ diaStatus == 2 ? '取消' : '拒绝' }}订单后，定金/划扣次数将退回顾客</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfirmCancelBespeak">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="yyDetails" title="预约详情" :visible.sync="detailsVisible" width="560px" :append-to-body="true" @close="close">
      <div class="yyTop">
        <i class="iconfont" :style="(detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4 || detailsInfo.status == 2) ? 'color: #67C23A;' : 'color: #C4C0C0'">{{ (detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4) ? '&#xe65e;' : ( detailsInfo.status == 2) ? '&#xe767;' : '&#xe65f;' }}</i>
        <span>{{ (detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4) ? '已预约' : ( detailsInfo.status == 2) ? '已完成' : '已取消' }}</span>
        <samp :style="(detailsInfo.status == 0 || detailsInfo.status == 1 || detailsInfo.status == 3 || detailsInfo.status == 4) ? 'color: #FA5555;' : 'color: #999;'">{{ detailsInfo.status == 0 ? '待服务' : detailsInfo.status == 1 ? '服务中' : detailsInfo.status == 3 ? '预约超时' : detailsInfo.status == 4 ? '待确认' : detailsInfo.status == -1 ? '商家取消' : detailsInfo.status == -2 ? '预约过期' : detailsInfo.status == -3 ? '用户取消' : detailsInfo.status == -4 ? '商家拒绝' : '' }}</samp>
      </div>
      <div class="yyInfoTitle">
        <span class="sl"></span>
        <span class="sm">预约信息</span>
      </div>
      <div class="yyInfo">
        <p>
          <span>姓名：</span>
          <samp>{{ detailsInfo.memberName }}</samp>
        </p>
        <p>
          <span>联系电话：</span>
          <samp>{{ detailsInfo.phone }}</samp>
        </p>
        <p>
          <span>预约时间：</span>
          <samp>{{ detailsInfo.bookDateTime }}</samp>
        </p>
        <p>
          <span>预约项目：</span>
          <samp>{{ detailsInfo.bookItemName }}</samp>
        </p>
        <p>
          <span>预约{{ Lib.collectively() }}：</span>
          <samp>{{ detailsInfo.bookTechnicianName }}</samp>
        </p>
        <p>
          <span>服务时长：</span>
          <samp>{{ detailsInfo.serviceTime }}分钟</samp>
        </p>
        <p>
          <span>备注：</span>
          <samp>{{ detailsInfo.remark || '--' }}</samp>
        </p>
      </div>
      <div class="yyInfoTitle">
        <span class="sl"></span>
        <span class="sm">其他信息：</span>
      </div>
      <div class="yyInfo">
        <p>
          <span>下单时间：</span>
          <samp>{{ detailsInfo.orderTime }}</samp>
        </p>
        <p>
          <span>来源：</span>
          <samp>{{ detailsInfo.orderSource }}</samp>
        </p>
        <p>
          <span>操作人：</span>
          <samp>{{ detailsInfo.dutyName }}</samp>
        </p>
        <h5 v-if="detailsInfo.orderCode">
          <span>订单号码：</span>
          <samp>{{ detailsInfo.orderCode }}</samp>
          <i v-if="seeOrder==1" class="el-icon-arrow-right" @click="lookOrder(detailsInfo,detailsInfo.orderId,detailsInfo.orderType,detailsInfo.orderStatus)"></i>
          <label v-if="seeOrder==1" @click="lookOrder(detailsInfo,detailsInfo.orderId,detailsInfo.orderType,detailsInfo.orderStatus)">查看订单</label>
        </h5>
      </div>
      <div v-if="(detailsInfo.status == -1 || detailsInfo.status == -2 || detailsInfo.status == -3 || detailsInfo.status == -4)" class="yyInfoTitle">
        <span class="sl"></span>
        <span class="sm">取消信息：</span>
      </div>
      <div v-if="(detailsInfo.status == -1 || detailsInfo.status == -2 || detailsInfo.status == -3 || detailsInfo.status == -4)" class="yyInfo">
        <p>
          <span>取消时间：</span>
          <samp>{{ detailsInfo.cancelTime }}</samp>
        </p>
        <p>
          <span>取消原因：</span>
          <samp>{{ detailsInfo.cancelCase }}</samp>
        </p>
      </div>
      <div class="yyFoot">
        <div v-if="detailsInfo.status == 0 || detailsInfo.status == 3">
          <el-button type="primary" @click="bespeakBilling(detailsInfo.orderId)">开单</el-button>
          <el-button type="primary" @click="bespeakEdit(detailsInfo.orderId,detailsInfo.orderSource)">修改</el-button>
          <el-button type="primary" @click="cancelBespeak(detailsInfo.orderId,2)">取消</el-button>
        </div>
        <div v-else-if="detailsInfo.status == 4">
          <el-button type="primary" @click="cancelBespeak(detailsInfo.orderId,1)">确认</el-button>
          <el-button type="primary" @click="cancelBespeak(detailsInfo.orderId,0)">拒绝</el-button>
        </div>
        <div v-else-if="detailsInfo.status == 1">
          <el-button type="primary" @click="settlementOrder(detailsInfo.orderId)">结算</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBookFailures,
  getSureOrFalse,
  getBookCancelMsg,
  getBookOrderDetail,
} from '../api';

export default {
  components: {},
  props: {
    // 是否有查看订单详情（默认0-从订单详情进入不查看,1-从预约详情模块进入需要展示）
    seeOrder: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      dialogVisible: false, // 取消预约--弹出框
      diaStatus: 3, // 弹出窗口文案提示状态
      cancelStatus: 1, // 取消预约退不退定金
      detailsVisible: false,
      detailsInfo: {},
    };
  },
  // 监听会员ID的变化
  watch: {},
  activated() {

  },
  mounted() { },
  methods: {
    open(detailData) {
      this.detailsVisible = true;
      this.bespeakDetails(detailData);
    },
    close() {
      this.detailsVisible = false;
      console.log(' this.detailsVisible', this.detailsVisible);
    },
    // 预约详情
    bespeakDetails(detailData) {
      if (this.Lib.checkPower('beauty-2-ckyy3') == false) return;
      this.detailsVisible = true;
      // orderId: detailData.bookOrderId
      getBookOrderDetail({ orderId: detailData.bookOrderMsgDTO.bookOrderId }).then((res) => {
        if (res.code == 0) {
          this.detailsInfo = res.data;
        }
      });
    },
    // 跳转到服务开单--所带参数
    bespeakBilling(id) {
      if (this.Lib.checkPower('beauty-2-yykd') == false) return;
      window.sessionStorage.editOrderId = '';
      window.sessionStorage.bookOrderId = id;
      this.$router.push({
        name: 'stage-serviceBilling'
      });
    },
    // 修改预约信息
    bespeakEdit(id, source) {
      if (this.Lib.checkPower('beauty-2-xgyy') == false) return;
      window.sessionStorage.bespeakId = id;
      if (source == 1) {
        this.$router.push({
          name: 'stage-bespeakTechnician'
        });
      } else {
        this.$router.push({
          name: 'stage-bespeakService'
        });
      }
    },
    // 取消预约
    cancelBespeak(id, val) {
      if (val === 2) {
        if (this.Lib.checkPower('beauty-2-qxyy') == false) return;
        getBookCancelMsg({ id }).then((res) => {
          if (res.code == 0) {
            this.chooseId = id;
            this.cancelStatus = res.data ? res.data.cancelStatus ? 1 : 0 : 0;
            this.diaStatus = val;
            this.dialogVisible = true;
          } else {
            console.log(res);
          }
        });
      } else if (val === 0) {
        if (this.Lib.checkPower('beauty-2-yyxxqr') == false) return;
        this.chooseId = id;
        this.diaStatus = val;
        this.cancelStatus = 1;
        this.dialogVisible = true;
      } else {
        if (this.Lib.checkPower('beauty-2-yyxxqr') == false) return;
        this.chooseId = id;
        this.diaStatus = val;
        this.cancelStatus = 1;
        this.isConfirm();
      }
    },
    // 确定取消预约
    comfirmCancelBespeak() {
      if (this.diaStatus === 2) {
        const data = {
          id: this.chooseId
        };
        getBookFailures(data).then((res) => {
          if (res.code == 0) {
            this.$message({ message: '取消成功', type: 'success' });
            this.dialogVisible = false;
            this.$emit('refreshData');
            // this.getListData();
          } else {
            console.log(res);
          }
        });
      } else {
        this.isConfirm();
      }
    },
    // 待确认状态修改  1是确认  0是拒绝
    isConfirm() {
      const data = {
        orderId: this.chooseId,
        type: this.diaStatus
      };
      getSureOrFalse(data).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: this.diaStatus == 1 ? '确认成功' : '拒绝成功',
            type: 'success'
          });
          this.dialogVisible = false;
          // this.getListData();
          this.$emit('refreshData');
        } else {
          this.$message(res.msg);
        }
      });
    },
    // 结算
    settlementOrder(id) {
      if (this.Lib.checkPower('beauty-2-yyjs') == false) return;
      window.sessionStorage.settlementOrderId = id;
      this.$router.push({
        name: 'stage-orderSettlement'
      });
    },
    // 查看订单
    lookOrder(v) {
      window.sessionStorage.orderData = window.JSON.stringify(v);
      this.$router.push({
        name: 'stage-orderDeatilsData',
        params: {
          orderId: v.orderId,
          orderType: v.orderType
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
.yyTop {
  background-color: #F5F7FA;
  height: 57px;
  line-height: 57px;
  padding: 0 20px;
  i {
    font-weight: 100;
    position: relative;
    top: 2px;
    font-size: 20px;
    font-weight: bold;
  }
  span {
    font-size: 18px;
    font-weight: bold;
    padding-left: 5px;
  }
  samp {
    font-size: 14px;
    color: #FA5555;
    float: right;
  }
}
.yyInfoTitle {
  padding: 20px 20px 0 20px;
  .sl {
    float: left;
    width: 5px;
    height: 15px;
    background-color: #409EFF;
    border-radius: 4px;
    position: relative;
    top: 2px;
    margin-right: 5px;
  }
  .sm {
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }
}
.yyInfo {
  display: table;
  p {
    display: flex;
    padding-top: 20px;
    line-height: 16px;
    font-size: 14px;
    span {
      width: 90px;
      float: left;
      text-align: right;
      color: #666;
    }
    samp {
      flex: 1;
      padding-right: 20px;
      color: #000;
    }
  }
  h5 {
    width: 560px;
    padding-top: 20px;
    line-height: 16px;
    font-size: 14px;
    span {
      width: 90px;
      float: left;
      text-align: right;
      color: #666;
    }
    samp {
      color: #000;
    }
    label {
      cursor: pointer;
      float: right;
      color: #409EFF;
    }
    i {
      cursor: pointer;
      float: right;
      color: #409EFF;
      padding: 0 20px 0 5px;
      position: relative;
      top: 1px;
    }
  }
}
.yyFoot {
  padding: 20px;
  float: right;
}
</style>

<style>
.yyDetails .el-dialog .el-dialog__body {
  padding: 0;
}
</style>
